export default __webpack_public_path__ + "static/img-south-china-morning-post-4f73217d2ee9b857f515597d4f73c271.png";